import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useState, useEffect } from 'react';
import api from '../api';
import Loading from '../components/Loading';
import CompanyGate from '../components/CompanyGate';
import { useI18n } from '../i18n/index.jsx';

function CashInner() {
  const { user, setPage } = useApp();
  const { t } = useI18n();
  const [txs, setTxs] = useState([]);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState({ company_id: '', tx_type: 'income', amount: '', category: '', description: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const [tr, b, c] = await Promise.all([
        api.get('/cash/tx'), api.get('/cash/balance'), api.get('/companies'),
      ]);
      setTxs(tr.data);
      setBalance(b.data);
      setCompanies(c.data);
      if (c.data.length && !form.company_id) setForm(f => ({ ...f, company_id: c.data[0].id }));
    } catch {}
    setLoading(false);
  }

  async function create() {
    setMsg('');
    try {
      await api.post('/cash/tx', { ...form, company_id: Number(form.company_id), amount: Number(form.amount) });
      setMsg('✅ ' + t('cash.added'));
      setShowForm(false);
      load();
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  if (loading) return <Loading />;

  const categories = t('cash.categories');

  if (showForm) return (
    <div className="page">
      <BackButton />
      <h1>💰 {t('cash.new_operation')}</h1>
      <div className="form">
        <div className="field"><label>{t('cash.type_label')}</label>
          <select value={form.tx_type} onChange={e => setForm({ ...form, tx_type: e.target.value })}>
            <option value="income">📈 {t('cash.type_income')}</option><option value="expense">📉 {t('cash.type_expense')}</option>
          </select></div>
        <div className="field"><label>{t('common.company')}</label>
          <select value={form.company_id} onChange={e => setForm({ ...form, company_id: e.target.value })}>
            {companies.map(c => <option key={c.id} value={c.id}>{c.short_name || c.name}</option>)}
          </select></div>
        <div className="field"><label>{t('cash.amount_label')}</label>
          <input type="number" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} /></div>
        <div className="field"><label>{t('cash.category_label')}</label>
          <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
            <option value="">--</option>
            {Array.isArray(categories) && categories.map(c => <option key={c} value={c}>{c}</option>)}
          </select></div>
        <div className="field"><label>{t('cash.description_label')}</label>
          <input value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></div>
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={create}>✅ {t('cash.add_operation')}</button>
        <button className="btn btn-secondary" onClick={() => setShowForm(false)}>{t('common.cancel')}</button>
      </div>
    </div>
  );

  return (
    <div className="page">
      <BackButton />
      <h1>💰 {t('cash.title')}</h1>
      {balance && (
        <div className="balance-card">
          <div className="balance-row"><span>📈 {t('cash.income_total')}:</span><span className="green">{balance.income?.toFixed(2)} PLN</span></div>
          <div className="balance-row"><span>📉 {t('cash.expense_total')}:</span><span className="red">{balance.expense?.toFixed(2)} PLN</span></div>
          <div className="balance-row balance-total"><span>💎 {t('cash.balance_total')}:</span><span>{balance.balance?.toFixed(2)} PLN</span></div>
        </div>
      )}
      <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ {t('cash.new_operation')}</button>
      {txs.length === 0 ? <div className="empty">{t('cash.no_operations')}</div> :
        <div className="list">
          {txs.map(tx => (
            <div key={tx.id} className="list-item">
              <div className="list-main">
                <div className="list-title">{tx.tx_type === 'income' ? '📈' : '📉'} {tx.description || tx.category || tx.tx_type}</div>
                <div className="list-sub">{tx.created_at?.split('T')[0]}</div>
              </div>
              <div className={`list-amount ${tx.tx_type === 'income' ? 'green' : 'red'}`}>
                {tx.tx_type === 'income' ? '+' : '-'}{tx.amount?.toFixed(2)} {tx.currency}
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default function Cash() {
  return <CompanyGate requireContract><CashInner /></CompanyGate>;
}
